import { IApiBaseResponse } from '~/utils/interface/common';
import axiosClient from './axiosClient';
import { IResponseGenerateSignEmbedUrl } from '~/utils/interface/esign';

const esignApi = {
  generateSignEmbedUrl(data: any) {
    return axiosClient.post<IApiBaseResponse<IResponseGenerateSignEmbedUrl>>(
      `api/admin/esign/generate-sign-embed-url`,
      data
    );
  },
};

export default esignApi;
